import * as Yup from "yup";

const purchaseSchema = {};

purchaseSchema.validateAdd = (values) => {
  const isZeroValueEnabled = values?.is_zero_value == "1";
  console.log("isZeroValueEnabled", isZeroValueEnabled);

  let schema = Yup.object({
    buyer_id: Yup.string().required("Supplier Name is Required."),
    po_date: Yup.date()
      .typeError("Purchase Order Date is Invalid")
      .required("Purchase Date is Required.")
      .min(
        new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30),
        "Purchase Date cannot be less than 30 days",
      ),
    inv_no: Yup.string()
      .required("Invoice No is Required.")
      .matches(/^[a-zA-Z0-9\-\/\\]+$/, `Invoice No must be alphanumeric`),
    purchase_type: Yup.string().required("Purchase Type is Required."),
    invoice_date: Yup.date()
      .typeError("Invoice Date is Invalid")
      .max(new Date(), "Invoice Date cannot be in the future")
      .nullable(),
    voucher_no: Yup.string().when("$isPurchaseVoucherNo", {
      is: 1,
      then: (schema) => schema.required("Voucher No is Required."),
      otherwise: (schema) => schema.nullable(),
    }),
    round_off: Yup.number()
      .typeError("Round Off must be number")
      .nullable(),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          po_qty: Yup.number()
            .typeError("Item Qty must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .when("$isZeroValueEnabled", {
              is: true,
              then: (schema) =>
                schema.min(0, "Item Reqd. Qty must be 0 or greater").nullable(),
              otherwise: (schema) =>
                schema
                  .moreThan(0, "Item Reqd. Qty must be greater than 0")
                  .required("Item Reqd. Qty field is required"),
            })
            .max(99999999.99, "Item Qty cannot exceed 8 Digits"),
          rate: Yup.number()
            .typeError("Item Rate must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .test(
              "rate-validation",
              "Item Rate field is required",
              function (value) {
                if (isZeroValueEnabled) {
                  return value !== null && value !== undefined && value >= 0;
                }
                return value !== null && value !== undefined && value > 0;
              },
            )
            .test(
              "rate-zero-validation",
              "Item Rate must be greater than 0",
              function (value) {
                if (
                  !isZeroValueEnabled &&
                  value !== null &&
                  value !== undefined &&
                  value <= 0
                ) {
                  return false;
                }
                return true;
              },
            )
            .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),
          amount: Yup.string().required("Item Amount is Required"),
          godown_id: Yup.string().required("Item Godown Name is Required"),
        }),
      )
      .min(1, "Invalid Product Details."),
  });

  return schema
    .validate(values, {
      abortEarly: false,
      context: {
        isZeroValueEnabled: values.is_zero_value == "1",
        isPurchaseVoucherNo: values.isPurchaseVoucherNo,
      },
    })
    .catch((err) => err);
};

purchaseSchema.validateEdit = (values) => {
  const isZeroValueEnabled = values?.is_zero_value == "1";
  console.log("valuesvaluesvalues", values);

  let schema = Yup.object({
    buyer_id: Yup.string().required("Supplier Name is Required."),

    po_date: Yup.date()
      .typeError("Purchase Order Date is Invalid")
      .required("Purchase Date is Required.")
      .min(
        new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30),
        "Purchase Date cannot be less than 30 days",
      ),

    inv_no: Yup.string()
      .required("Invoice No is Required.")
      .matches(/^[a-zA-Z0-9\-\/\\]+$/, `Invoice No must be alphanumeric`),
    purchase_type: Yup.string().required("Purchase Type is Required."),
    invoice_date: Yup.date()
      .typeError("Invoice Date is Invalid")
      .max(new Date(), "Invoice Date cannot be in the future")
      .nullable(),
    voucher_no: Yup.string().when("$isPurchaseVoucherNo", {
      is: 1,
      then: (schema) => schema.required("Voucher No is Required."),
      otherwise: (schema) => schema.nullable(),
    }),
    round_off: Yup.number().typeError("Round Off must be number").nullable(),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),

          po_qty: Yup.number()
            .typeError("Item Qty must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .when("$isZeroValueEnabled", {
              is: true,
              then: (schema) =>
                schema.min(0, "Item Qty must be 0 or greater").nullable(),
              otherwise: (schema) =>
                schema
                  .moreThan(0, "Item Qty must be greater than 0")
                  .required("Item Qty field is required"),
            })
            .max(99999999.99, "Item Qty cannot exceed 8 Digits"),

          rate: Yup.number()
            .nullable()
            .typeError("Item Rate must be number")
            .transform((value, originalValue) =>
              originalValue === "" || originalValue === null
                ? null
                : Number(originalValue),
            )
            .test(
              "rate-validation",
              "Item Rate field is required",
              function (value) {
                if (isZeroValueEnabled) {
                  return value !== null && value !== undefined && value >= 0;
                }
                return value !== null && value !== undefined && value > 0;
              },
            )
            .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),

          amount: Yup.string().required("Item Amount is Required"),

          godown_id: Yup.string().required("Item Godown Name is Required"),
        }),
      )
      .min(1, "Invalid Product Details."),
  });

  return schema
    .validate(values, {
      abortEarly: false,
      context: {
        isZeroValueEnabled: values.is_zero_value == "1",
        isPurchaseVoucherNo: values.isPurchaseVoucherNo,
      },
    })
    .catch((err) => err);
};

export default purchaseSchema;
